export enum AuthActionType {
  SetState = 'AUTH.SET_STATE',
  REGISTRATION = 'AUTH.REGISTRATION',
  REGISTRATION_ACTIVE = 'AUTH.REGISTRATION_ACTIVE',
  RESET_PASSWORD = 'AUTH.RESET_PASSWORD',
  SIGN_IN = 'AUTH.SIGN_IN',
  SIGN_OUT = 'AUTH.SIGN_OUT',
  GET_COUNTRY = 'AUTH.GET_COUNTRY',
  VERIFICATION = 'AUTH.VERIFICATION',
}
